export const ClientDetailsGetters = {
  GetClientDetails: 'getClientDetails',
  GetClientDetailsReferenceNumber: 'getClientDetailsReferenceNumber',
  GetClientDetailsAddressList: 'getClientDetailsAddressList',
  GetClientDetailsContactsList: 'getClientDetailsContactsList',
  GetClientDetailsContactsRecordsPerPage: 'getClientDetailsContactsRecordsPerpage',
  GetClientDetailsContactsRecordsOffset: 'getClientDetailsContactsRecordsOffset',
  GetClientDetailsContactsRecordsCount: 'getClientDetailsContactsRecordsCount',
  GetClientDetailsContactsIsLoading: 'getClientDetailsContactsIsLoading',
  GetClientDetailsBillingMethodsList: 'getClientDetailsBillingMethodsList',
  GetClientDetailsBillingRecordsPerPage: 'getClientDetailsBillingRecordsPerpage',
  GetClientDetailsBillingRecordsOffset: 'getClientDetailsBillingRecordsOffset',
  GetClientDetailsBillingRecordsCount: 'getClientDetailsBillingRecordsCount',
  GetClientDetailsBillingIsLoading: 'getClientDetailsBillingIsLoading',
  GetClientDetailsUpdateStatus: 'getClientDetailsUpdateStatus',
  GetClientDetailsHistories: 'getClientDetailsHistories',
  GetClientAttachments: 'getClientAttachments'
};
export const ClientsDetailsMutations = {
  SetClientDetails: 'setClientDetails',
  UpdateClientDetails: 'updateClientDetails',
  SetClientDetailsAddressList: 'setClientDetailsAddressList',
  RemoveClientDetailsAddress: 'removeClientDetailsAddress',
  UpdateClientDetailsAddress: 'updateClientDetailsAddress',
  AddClientDetailsAddress: 'addClientDetailsAddress',
  SetClientDetailsReferenceNumber: 'setClientDetailsReferenceNumber',
  SetClientDetailsContactsList: 'setClientDetailsContactsList',
  SetClientDetailsContactsRecordsCount: 'setClientDetailsContactsRecordsCount',
  SetClientDetailsContactsPaginationParameters: 'setClientDetailsContactsPaginationParameters',
  SetClientDetailsContactsIsLoading: 'setClientDetailsContactsIsLoading',
  ResetClientDetailsContactsPaginationPropertyOffset:
    'resetClientDetailsContactsPaginationPropertyOffset',
  SetClientDetailsContactsSearchParam: 'setClientDetailsContactsSearchParam',
  SetClientDetailsBillingMethodsList: 'setClientDetailsBillingMethodsList',
  SetClientDetailsBillingRecordsCount: 'setClientDetailsBillingRecordsCount',
  SetClientDetailsBillingPaginationParameters: 'setClientDetailsBillingPaginationParameters',
  SetClientDetailsBillingIsLoading: 'setClientDetailsBillingIsLoading',
  ResetClientDetailsBillingPaginationPropertyOffset:
    'resetClientDetailsBillingPaginationPropertyOffset',
  RemoveClientDetailsBillingMethod: 'removeClientDetailsBillingMethod',
  AddClientDetailsBillingMethod: 'addClientDetailsBillingMethod',
  UpdateClientDetailsBillingMethod: 'updateClientDetailsBillingMethod',
  SetClientDetailsUpdateStatus: 'setClientDetailsUpdateStatus',
  UpdateClientDefaultAddress: 'updateClientDefaultAddress',
  UpdateClientDefaultBillingMethod: 'updateClientDefaultBillingMethod',
  ResetClientDetails: 'resetClientDetails',
  SetClientDetailsHistories: 'setClientDetailsHistories',
  SetClientAttachment: 'setClientAttachment'
};
export const ClientDetailsActions = {
  RetrieveClientDetails: 'retrieveClientDetails',
  RetrieveClientContactDetails: 'retrieveClientContactDetails',
  UpdateClientDetails: 'updateClientDetails',
  UpdateClientDetailsAddress: 'updateClientDetailsAddress',
  RemoveAddress: 'removeClientDetailsAddress',
  AddAddress: 'addClientDetailsAddress',
  SetClientDetailsContactsList: 'setClientDetailsContactsList',
  SetClientDetailsBillingMethodsList: 'setClientDetailsBillingMethodsList',
  ClientDetailsBillingPaginationParametersUpdate: 'clientDetailsBillingPaginationParametersUpdate',
  ClientDetailsContactsPaginationParametersUpdate:
    'clientDetailsContactsPaginationParametersUpdate',
  ClientDetailsContactsSearchUpdate: 'ClientDetailsContactsSearchUpdate',
  RetrieveClientDetailsContactsUpdate: 'retrieveClientDetailsContactsUpdate',
  RemoveClientDetailsBillingMethod: 'removeClientDetailsBillingMethod',
  AddClientDetailsBillingMethod: 'addClientDetailsBillingMethod',
  UpdateClientDetailsBillingMethod: 'updateClientDetailsBillingMethod',
  SaveClientDetails: 'saveClientDetails',
  UpdateClientDefaultAddress: 'updateClientDefaultAddress',
  UpdateClientDefaultBillingMethod: 'updateClientDefaultBillingMethod',
  ResetClientDetails: 'resetClientDetails',
  GetClientDetailsHistories: 'getClientDetailsHistories',
  ClientAttachments: 'getClientAttachments',
  RetrieveClientAttachments: 'retrieveClientAttachments'
};
